"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WstEthOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var WstEthOracleFactory = /** @class */ (function (_super) {
    __extends(WstEthOracleFactory, _super);
    function WstEthOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    WstEthOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    WstEthOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    WstEthOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    WstEthOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    WstEthOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return WstEthOracleFactory;
}(contracts_1.ContractFactory));
exports.WstEthOracleFactory = WstEthOracleFactory;
var _abi = [
    {
        inputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "chainLinkEthAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "chainlinkEthScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "stETHCrvPoolAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "wstETHAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
